import Confetti from 'react-confetti'
import useWindowSize from 'lib/hooks/useWindowSize'
import { useEffect, useState } from 'react'
import css from './ConfettiOverlayPrimer.styles.scss'

export const ConfettiOverlayPrimer = () => {
  const { width, height } = useWindowSize()
  const [showConfetti, setShowConfetti] = useState(true)
  const [fadeIn, setFadeIn] = useState(false)

  useEffect(() => {
    setFadeIn(true)
  }, [])

  return (
    <div
      className={`${css.ConfettiOverlayContainer} ${fadeIn ? css.fadeIn : ''}`}
    >
      {showConfetti && (
        <Confetti
          numberOfPieces={600}
          recycle={false}
          width={width}
          height={height}
          onConfettiComplete={() => setShowConfetti(false)}
        />
      )}
    </div>
  )
}
